import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  getCitiesData,
  getPropertTypeData,
  getLeverageData,
  getSearchHistoryData,
  getMarketPlaceSearch,
  postSearchHistory,
} from "../../services/FiltersApi/filters";
import { toastNotify } from "../../utils/toastNotify";

const initialState = {
  loading: true,
  filterApply: false,
  cityData: [],
  propertyTypeData: [],
  leverageData: [],
  searchHistoryData: {},
  marketPlaceSearch: [],
};
export const fetchFiltersCitiesListAction = createAsyncThunk(
  "FETCH_LIST_OF_CITIES",
  getCitiesData
);
export const fetchFiltersPropertTypeListAction = createAsyncThunk(
  "FETCH_LIST_OF_PROPERTY_TYPE",
  getPropertTypeData
);
export const fetchFiltersLeverageAction = createAsyncThunk(
  "FETCH_LIST_OF_LEVERAGE",
  getLeverageData
);
export const fetchSearchHistoryAction = createAsyncThunk(
  "FETCH_LIST_SEARCH_HISTORY",
  getSearchHistoryData
);
export const featchMarketPlaceSearchAction = createAsyncThunk(
  "FETCH_LIST_MARKET_PLACE_SEARCH",
  getMarketPlaceSearch
);
export const postSearchHistoryAction = createAsyncThunk(
  "POST_SEARCH-HISTORY_RESULT",
  postSearchHistory
);

export const filtersSlice = createSlice({
  name: "propertyDetails",
  initialState,
  reducers: {
    updateFilterApply: (state, action) => {
      state.filterApply = action.payload
    }
  },
  extraReducers: {
    [fetchFiltersCitiesListAction.pending]: (state, action) => {
      return {
        ...state,
        loading: true,
      };
    },
    [fetchFiltersCitiesListAction.fulfilled]: (state, action) => {
      return {
        ...state,
        loading: false,
        cityData: action.payload,
      };
    },
    [fetchFiltersCitiesListAction.rejected]: (state, action) => {
      toastNotify("error", action.payload);
      return {
        ...state,
        loading: false,
        cityData: [],
      };
    },
    [fetchFiltersPropertTypeListAction.pending]: (state, action) => {
      return {
        ...state,
        loading: true,
      };
    },
    [fetchFiltersPropertTypeListAction.fulfilled]: (state, action) => {
      return {
        ...state,
        loading: false,
        propertyTypeData: action.payload,
      };
    },
    [fetchFiltersPropertTypeListAction.rejected]: (state, action) => {
      toastNotify("error", action.payload);
      return {
        ...state,
        loading: false,
        propertyTypeData: [],
      };
    },
    [fetchFiltersLeverageAction.pending]: (state, action) => {
      return {
        ...state,
        loading: true,
      };
    },
    [fetchFiltersLeverageAction.fulfilled]: (state, action) => {
      return {
        ...state,
        loading: false,
        leverageData: action.payload,
      };
    },
    [fetchFiltersLeverageAction.rejected]: (state, action) => {
      toastNotify("error", action.payload);
      return {
        ...state,
        loading: false,
        leverageData: [],
      };
    },
    [featchMarketPlaceSearchAction.pending]: (state, action) => {
      return {
        ...state,
        loading: true,
      };
    },
    [featchMarketPlaceSearchAction.fulfilled]: (state, action) => {
      return {
        ...state,
        loading: false,
        searchHistoryData: {
          search: true,
          data: action.payload?.data?.searchResult
        },
      };
    },
    [featchMarketPlaceSearchAction.rejected]: (state, action) => {
      toastNotify("error", action.payload);
      return {
        ...state,
        loading: false,
        searchHistoryData: {},
      };
    },
    [fetchSearchHistoryAction.pending]: (state, action) => {
      return {
        ...state,
        loading: true,
      };
    },
    [fetchSearchHistoryAction.fulfilled]: (state, action) => {
      return {
        ...state,
        loading: false,
        searchHistoryData: {
          search: false,
          data: action.payload?.data?.searchHistory
        },
      };
    },
    [fetchSearchHistoryAction.rejected]: (state, action) => {
      return {
        ...state,
        loading: false,
        searchHistoryData: {}
      };
    },
    [postSearchHistoryAction.pending]: (state, action) => {
      return {
        ...state,
        loading: true,
      };
    },
    [postSearchHistoryAction.fulfilled]: (state, action) => {
      return {
        ...state,
        loading: false,
      };
    },
    [postSearchHistoryAction.rejected]: (state, action) => {
      toastNotify("error", action.payload);
      return {
        ...state,
        loading: false,
        cityData: [],
      };
    },
  },
});
export const { 
  updateFilterApply
} = filtersSlice.actions;
const { reducer } = filtersSlice;
export default reducer;
